export const websiteUrlRegex =
  // eslint-disable-next-line no-useless-escape
  /^(http[s]?:\/\/(www\.)?|ftp:\/\/(www\.)?|www\.){1}([0-9A-Za-z-\.@:%_\+~#=]+)+((\.[a-zA-Z]{2,3})+)(\/(.)*)?(\?(.)*)?/g

export const FORM_MODE = 'onSubmit'

export const EMAIL_REGEX = /\S+@\S+\.\S+/
